<template>
  <div>
    <div class="gray-text mb-4">
      <v-chip
        label
        small
        outlined
        class="mr-1"
        :color="h1Similar ? 'success' : null"
      >
        h1
      </v-chip>
      {{ h1 }}
    </div>

    <div class="overline mt-2">
      Table of Content (H2..H6)
    </div>

    <v-treeview
      class="gray-text"
      dense
      :items="toc"
      :open-all="openAll"
    >
      <template #prepend="{ item }">
        <div class="gray-text">
          <v-chip
            label
            small
            outlined
            :color="item.similar ? 'success' : null"
          >
            {{ item.tag }}
          </v-chip>
        </div>
      </template>
      <template #label="{ item }">
        <div class="gray-text">
          {{ item.name }}
        </div>
      </template>
    </v-treeview>
  </div>
</template>

<script>
export default {
  props: {
    h1: {
      type: String,
      default: null
    },
    h1Similar: {
      type: Boolean,
      default: false
    },
    toc: {
      type: Array,
      default: () => []
    },
    openAll: {
      type: Boolean,
      default: false
    },
  },
}
</script>
